<template lang="html">
  <div class="main-container">
    <section class="double-top-pad">
      <div class="top-block"></div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h1 v-html="press.title"></h1>

            <div class="press-entry-grid">
              <button
                v-for="(article, index) in articles"
                :key="index"
                class="press-entry"
                v-observe
                :aria-label="`Read article: ${article.label}`"
                @click="openModal(index)"
              >
                <div class="press-entry-image">
                  <img
                    :src="'static/img/press/' + article.thumb"
                    loading="lazy"
                  />
                </div>

                <div
                  class="press-rollover"
                  :style="{
                    backgroundColor:
                      shades[Math.floor(Math.random() * shades.length)],
                  }"
                >
                  <img :src="'static/img/logos/' + article.thumb_over" />
                  <div class="press-rollover-date">{{ article.date }}</div>
                </div>

                <!-- <div class="press-entry-content">
                  <h3 v-html="article.label"></h3>
                  <a :href="article.link" target="_blank">Read more</a>
                </div> -->
              </button>
            </div>

            <router-link :to="'/'">
              <button
                class="block-button back-button"
                aria-label="Go back to homepage"
              >
                <div class="mybutton-up">BACK</div>
                <div class="mybutton-down">BACK</div>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="name-section name-section-small">
      <div class="name-section-inner name-section-inner-black"></div>
    </section>

    <!-- <section class="press-modal" v-if="isOpen === true">
      <iframe
        :src="`static/img/press/${currentImage.clipping}`"
        width="100%"
        height="100%"
        style="border: none"
      ></iframe>
      <button
        class="block-button social-button"
        @click="closeModal()"
        aria-label="Close modal"
      >
        <div class="mybutton-up">
          <i class="fas fa-times" aria-hidden="true"></i>
        </div>
        <div class="mybutton-down">
          <i class="fas fa-times" aria-hidden="true"></i>
        </div>
      </button>
    </section> -->
  </div>
</template>

<style type="text/css"></style>

<script>
import { press } from "../../content.json";
// var dataURL = 'https://api.ralphandco.com/updates'
import { commontools } from "../mixins/Styling";

export default {
  mixins: [commontools],
  name: "press",
  watch: {
    "$route.name": function (id) {
      window.scrollTo(0, 0);
    },
  },
  data() {
    return {
      press,
      articles: [],
      isOpen: false,
      currentImage: null,
      shades: ["#A9DBC9", "#B7E1D2", "#B8E0D0", "#8DCEB6", "#9AD5C0"],
    };
  },
  directives: {
    observe: {
      inserted(el) {
        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                el.classList.add("visible");
                obs.unobserve(el); // stop observing once visible
              }
            });
          },
          { threshold: 0.1 } // start fading in when 10% visible
        );
        observer.observe(el);
      },
    },
  },
  methods: {
    openModal(id) {
      const article = this.articles[id];
      if (article.clipping) {
        // Show modal with clipping image

        window.open(`static/img/press/${article.clipping}`, "_blank");
        // if (window.innerWidth < 768) {
        //   window.open(`static/img/press/${article.clipping}`, "_blank");
        //   return;
        // }

        // this.currentImage = article;
        // this.isOpen = true;

        // document.body.style.overflow = "hidden";
        // document.body.style.height = "100%";
      } else if (article.link) {
        // No clipping → open the link instead
        window.open(article.link, "_blank");
      }
    },
    closeModal() {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
      this.isOpen = false;
    },
  },
  created: function () {},
  mounted: function () {
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.articles = press.articles;
    }, 100);
  },
  components: {},
};
</script>

<style scoped lang="scss">
button {
  border: none;
  background-color: transparent;
}

.press-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  padding: 30px 30px;

  a {
    color: #fff;
    text-decoration: none;

    .modal-link {
      position: absolute;
      bottom: 46px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      border: 1px solid #fff;

      font-family: "titling-gothic", "Helvetica Neue", Helvetica, Arial,
        sans-serif !important;
      height: 34px;
      padding: 0px 12px;
      line-height: 34px;
      text-decoration: none;
      text-transform: uppercase;
      transition: 0.3s ease;
      background-color: rgba(202, 232, 220, 0.3);
      font-size: 14px;
      &:hover {
        background-color: rgba(202, 232, 220, 0.9);

        color: #000;
      }
    }
  }

  .modal-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }

  .block-button {
    position: absolute;
    top: 24px;
    right: 24px;

    .mybutton-up {
      background: #fff;
      color: #000;
    }
    .mybutton-down {
      background: #cae8dc;
      color: #000;
    }
  }
}

.press-entry-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columns */
  grid-auto-rows: 24vw; /* base row height */
  gap: 2px; /* spacing */
  min-height: 70vh;

  @media (max-width: 767.98px) {
    grid-template-columns: repeat(3, 1fr); /* 3 columns */
    grid-auto-rows: 32vw; /* base row height */
  }
}
.press-entry {
  background: #fff;
  border-radius: 0px;
  background: #cae8dc;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  padding: 0;
  border: none;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &:nth-child(19n + 1) {
    grid-column: span 2;
    grid-row: span 2;
  }
  &:nth-child(19n + 2) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 3) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 4) {
    grid-column: span 2;
    grid-row: span 1;
  }
  &:nth-child(19n + 5) {
    grid-column: span 1;
    grid-row: span 2;
  }
  &:nth-child(19n + 6) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 7) {
    grid-column: span 2;
    grid-row: span 1;
  }
  &:nth-child(19n + 8) {
    grid-column: span 2;
    grid-row: span 1;
  }
  &:nth-child(19n + 9) {
    grid-column: span 1;
    grid-row: span 2;
  }
  &:nth-child(19n + 10) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 11) {
    grid-column: span 2;
    grid-row: span 2;
  }
  &:nth-child(19n + 12) {
    grid-column: span 1;
    grid-row: span 2;
  }
  &:nth-child(19n + 13) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 14) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 15) {
    grid-column: span 2;
    grid-row: span 1;
  }
  &:nth-child(19n + 16) {
    grid-column: span 2;
    grid-row: span 1;
  }
  &:nth-child(19n + 17) {
    grid-column: span 2;
    grid-row: span 2;
  }
  &:nth-child(19n + 18) {
    grid-column: span 1;
    grid-row: span 1;
  }
  &:nth-child(19n + 19) {
    grid-column: span 1;
    grid-row: span 1;
  }

  @media (max-width: 767.98px) {
    &:nth-child(10n + 1) {
      grid-column: span 2;
      grid-row: span 2;
    }
    &:nth-child(10n + 2) {
      grid-column: span 1;
      grid-row: span 1;
    }
    &:nth-child(10n + 3) {
      grid-column: span 1;
      grid-row: span 1;
    }
    &:nth-child(10n + 4) {
      grid-column: span 2;
      grid-row: span 1;
    }
    &:nth-child(10n + 5) {
      grid-column: span 1;
      grid-row: span 2;
    }
    &:nth-child(10n + 6) {
      grid-column: span 2;
      grid-row: span 1;
    }
    &:nth-child(10n + 7) {
      grid-column: span 1;
      grid-row: span 1;
    }
    &:nth-child(10n + 8) {
      grid-column: span 2;
      grid-row: span 2;
    }
    &:nth-child(10n + 9) {
      grid-column: span 1;
      grid-row: span 2;
    }
    &:nth-child(10n + 10) {
      grid-column: span 2;
      grid-row: span 1;
    }
  }

  .press-entry-image {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: all 0.3s ease;
    }
  }
  .press-rollover {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    opacity: 1;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    img {
      width: 70%;

      max-width: 320px;
      object-fit: contain;
      object-position: center;
    }

    .press-rollover-date {
      font-size: 16px;
      font-family: "Univers", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 400;
      text-align: center;
      line-height: 16px;
    }

    @media screen and (max-width: 767.98px) {
      img {
        width: 80%;
        max-width: 150px;
      }

      .press-rollover-date {
        font-size: 14px;
        line-height: 14px;
      }
    }
  }

  @media (hover: hover) {
    &:hover {
      .press-entry-image img {
        transform: scale(1.1);
        filter: brightness(0.9);
        opacity: 1;
      }
      .press-rollover {
        opacity: 0;
      }
    }
  }

  &:active {
    .press-entry-image img {
      opacity: 1;
    }
    .press-rollover {
      opacity: 0;
    }
  }
}
</style>
